<template>
  <div class="changeTel">
    <van-field
      class="input"
      center
      placeholder="请输入手机号码"
      v-model="tel"
    />
    <div class="btn" @click="changeTel">保存</div>
  </div>
</template>

<script>
import { Field, Button, Toast } from "vant";
import { postUserContact } from "@/api/public";
export default {
  name: "ChangeTel",
  components: {
    [Field.name]: Field,
    [Button.name]: Button
  },
  data() {
    return {
      tel: ""
    };
  },
  mounted() {
    this.tel = this.$route.query.tel;
  },
  methods: {
    changeTel() {
      console.log(this.tel);
      if (!/^1(3|4|5|7|8|9|6)\d{9}$/.test(this.tel)) {
        return Toast({ message: "请填写正确的手机号" });
      }
      postUserContact({ phone: this.tel })
        .then(res => {
          if (res.status == 200) {
            if (res.status == 200) {
              Toast({ message: "修改成功" });
              this.$router.replace({ path: "/my/card" });
            } else {
              Toast({ message: "修改失败" });
            }
          }
        })
        .catch(err => {
          Toast({ message: err.msg || "修改失败" });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.changeTel {
  .input {
    margin-top: 0.2rem;
    height: 1rem;
  }
  .btn {
    margin: 0.36rem 0.3rem 0 0.3rem;
    background: #ff410a;
    line-height: 0.8rem;
    text-align: center;
    border-radius: 0.16rem;
    color: #ffffff;
    letter-spacing: 0.06rem;
  }
}
</style>
